import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { lang } from '@config'
import { Form, Row, Col } from 'react-bootstrap'

import { Input } from "@inspinia-react/form/input";
import { setBasePersonName, setBasePersonEmail, setBasePersonPhoneNumber } from "./actions";
import { mapTest } from "../../pages/products/map.test";
//const basePerson = lang.common.person;

function BasePerson(props) {
  const { type } = props
  const nameLabel = type == 0 ? 'Seu nome' : 'Razão Social'
  const namePlaceholder = `Informe aqui ${type == 0 ? 'o seu nome' : 'a Razão Social da empresa'}`
  const emailLabel = type == 0 ? 'Seu email' : 'Email da empresa'
  const emailPlaceholder = `Informe aqui ${type == 0 ? 'o seu email' : 'o email da empresa'}`
  const phoneNumberLabel = type == 0 ? 'Seu telefone' : 'telefone da empresa'
  const phonePlaceholder = `Informe aqui ${type == 0 ? 'o seu telefone' : 'o telefone da empresa'}`

  return <Form>
    <Form.Row>
      <Form.Group as={Col}>
        <Form.Label>{nameLabel}</Form.Label>
        <Form.Control
          id={mapTest.createBranch.info.fields.inputBranchName}
          placeholder={namePlaceholder}
          maxLength={60}
          value={props.name}
          onChange={e => props.setBasePersonName(e.target.value.replace(/[&$%#@\\|]/g, ''))} />
        <div className='px-3 row d-flex justify-content-between'>
          <span>máx. 60 caracteres.</span>
          <span className='justify-content-end'>{props.name.length}/60</span>
        </div>
      </Form.Group>
    </Form.Row>
    <div className="row">
      <div className="col-lg-6 col-sm-12">
        <Form.Label>{emailLabel}</Form.Label>
        <Form.Control
          id={mapTest.createBranch.info.fields.inputBranchEmail}
          value={props.email}
          placeholder={emailPlaceholder}
          onChange={e => {
            const normalizedValue = e.target.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            props.setBasePersonEmail(normalizedValue);
          }}
          
          />
      </div>
      <div className="col-lg-6 col-sm-12">
        <Form.Label>{phoneNumberLabel}</Form.Label>
        <Input
          id={mapTest.createBranch.info.fields.inputBranchPhone}
          mask="(99) 99999-9999"
          placeholder={phonePlaceholder}
          onChange={e => props.setBasePersonPhoneNumber(e)}
          label="Telefone"
          value={props.phone_number}
        />
      </div>
    </div>
  </Form>
}
const mapStateToProps = state => ({
  clients: state.clientsList,
  name: state.basePersonName,
  email: state.basePersonEmail,
  phone_number: state.basePersonPhone,
  type: state.personType
});
const mapDispathToProps = dispatch =>
  bindActionCreators(
    {
      setBasePersonName,
      setBasePersonEmail,
      setBasePersonPhoneNumber
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispathToProps)(BasePerson);




// WEBPACK FOOTER //
// ./src/components/parts/base-person/index.jsx